/**
 * 노드 종류 타입 가드 — `instanceof Konva.X` 판정의 렌더러 중립 대체(INode.kind 기반).
 * 주의: `instanceof Konva.Line`은 Arrow(하위 클래스)도 참이므로 isLineNode는 'Line'·'Arrow' 둘 다 받는다.
 */
import type { IArrow, IEllipse, IGroup, ILine, INode, IRect, IShape, IText } from './IRenderer'

export function isRectNode(n: INode | null | undefined): n is IRect {
  return !!n && n.kind === 'Rect'
}

export function isEllipseNode(n: INode | null | undefined): n is IEllipse {
  return !!n && n.kind === 'Ellipse'
}

/** Konva.Line 또는 그 하위 Konva.Arrow */
export function isLineNode(n: INode | null | undefined): n is ILine {
  return !!n && (n.kind === 'Line' || n.kind === 'Arrow')
}

export function isArrowNode(n: INode | null | undefined): n is IArrow {
  return !!n && n.kind === 'Arrow'
}

export function isTextNode(n: INode | null | undefined): n is IText {
  return !!n && n.kind === 'Text'
}

export function isGroupNode(n: INode | null | undefined): n is IGroup {
  return !!n && n.kind === 'Group'
}

/** Konva.Shape 계열(그리기 노드) */
export function isShapeNode(n: INode | null | undefined): n is IShape {
  return (
    !!n &&
    n.kind !== 'Stage' &&
    n.kind !== 'Layer' &&
    n.kind !== 'Group' &&
    n.kind !== 'Transformer' &&
    n.kind !== 'Node'
  )
}
